import {CONSONANT_VOWEL_PAIRS_JJ} from "../../../SubjectData/Phonetics/ConsonantVowelPairs/ConsonantVowelPairs_jj";
import "../../Deck.css";
import FlashcardInterface from "../../Flashcard_Interface.js";
import HeaderNav from "../../../Components/Header/Header_Nav/Header_Nav.js";



export default function CONSONANT_VOWEL_PAIRS_JJ_Deck() {


 return(
 
     <>
        <HeaderNav GoBack_to={"/ConsonantVowelPairsNav"}/>
        <FlashcardInterface deckData={CONSONANT_VOWEL_PAIRS_JJ} title="Consonant-Vowel Pairs: jj (ㅉ)" />
     </>
);}